import styled from "styled-components";

const MainContainer = styled.div`
  width: 100%;
  border-radius: 10px;
  background-color: #ffffff;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  gap: 10px;
  padding: 14px 9px 14px 20px;
  box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.04);

  .panel-icon {
    width: 46px;
    height: 46px;
    border-radius: 50%;
    background-color: #d9d9d9;
    display: flex;
    flex-direction: row;
    justify-content: center;
  }
  .panel-text {
    flex: 1;
    display: flex;
    flex-direction: column;
    gap: 5px;
    //border: 1px solid blue;
    .panel-sup {
      width: 100%;
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      align-items: center;
      gap: 5px;
      //border: 1px solid green;
      > .label-quantity {
        font-family: "Roboto";
        font-size: 18px;
        font-weight: 700;
        text-align: left;
        color: #13131d;
      }
    }
    > .label-title {
      font-family: "Roboto";
      font-size: 13px;
      font-weight: 400;
      text-align: left;
      color: #a0a0a0;
    }
  }
`;

export default {
  MainContainer,
};
